import loadEnvironment from 'envc'

const parseBoolean = (value: string, trueValues: Array = ['true', '1', 'TRUE']) => trueValues.includes(value)

loadEnvironment({overwrite: true})

const koaPort = parseInt(process.env.KOA_PORT, 10)

export default {
  KOA_PORT: koaPort,
  DEV_HOT_RELOADING: parseBoolean(process.env.DEV_HOT_RELOADING || 'false'),
  DEV_HOT_RELOADING_PORT: parseInt(process.env.DEV_HOT_RELOADING_PORT || `${koaPort + 1}`, 10),
  DEV_HTTPS: parseBoolean(process.env.DEV_HTTPS),
  NODE_ENV: process.env.NODE_ENV,
  LOADER_TIMEOUT: parseInt(process.env.LOADER_TIMEOUT, 10),
  ARRIVA_XC_ENDPOINT: process.env.ARRIVA_XC_ENDPOINT,
  ARRIVA_XC_COOKIE_NAME_CURRENT_REGION: process.env.ARRIVA_XC_COOKIE_NAME_CURRENT_REGION,
  ARRIVA_XC_COOKIE_NAME_CURRENT_REGION_ID: process.env.ARRIVA_XC_COOKIE_NAME_CURRENT_REGION_ID,
  ARRIVA_XC_COOKIE_NAME_FONT_SIZE_INCREASED: process.env.ARRIVA_XC_COOKIE_NAME_FONT_SIZE_INCREASED,
  ARRIVA_XC_COOKIE_DOMAIN: process.env.ARRIVA_XC_COOKIE_DOMAIN,
  SESSION_TIMEOUT_IN_MS: parseInt(process.env.SESSION_TIMEOUT_IN_MS, 10),
  ENABLE_VUEX_LOG: parseBoolean(process.env.ENABLE_VUEX_LOG),
  AUTHENTICATION_SERVICE_HOST: process.env.AUTHENTICATION_SERVICE_HOST,
  AUTHENTICATION_SERVICE_USE_HTTPS: parseBoolean(process.env.AUTHENTICATION_SERVICE_USE_HTTPS),
  USE_MOCK_AUTHENTICATION_CLIENT: parseBoolean(process.env.USE_MOCK_AUTHENTICATION_CLIENT),
  JWT_SECRET: process.env.JWT_SECRET,
  ASSIST_SERVICE_HOST: process.env.ASSIST_SERVICE_HOST,
  ASSIST_SERVICE_USE_HTTPS: parseBoolean(process.env.ASSIST_SERVICE_USE_HTTPS),
  USE_MOCK_B2B_CLIENT: parseBoolean(process.env.USE_MOCK_B2B_CLIENT),
  SENTRY_ENABLE: parseBoolean(process.env.SENTRY_ENABLE),
  SENTRY_DSN: process.env.SENTRY_DSN,
  LOG_API_CALLS: parseBoolean(process.env.LOG_API_CALLS || 'true')
}



// WEBPACK FOOTER //
// ./src-server/config.js